import * as XLSX from "xlsx";
import {
  getRegistrationDetailFields,
  getRegistrationFieldLabel,
  getRegistrationFieldValue,
} from "./registrationFields";

interface RegistrationExportRow {
  registration_data?: Record<string, unknown>;
  submitted_at?: string;
  payment_intent_id?: string | null;
  attendanceStatus?: string;
}

export function exportRegistrationsToExcel(
  registrations: RegistrationExportRow[],
  eventName: string,
  registrationFields?: string[],
  options?: { includeAttendance?: boolean }
): void {
  const fieldIds = getRegistrationDetailFields(registrationFields);

  const rows = registrations.map((registration) => {
    const data = registration.registration_data;
    const row: Record<string, string> = {
      Submitted: registration.submitted_at
        ? new Date(registration.submitted_at).toLocaleString()
        : "",
    };

    fieldIds.forEach((fieldId) => {
      const label = getRegistrationFieldLabel(fieldId);
      const value = getRegistrationFieldValue(data, fieldId);
      row[label] = value === "-" ? "" : value;
    });

    if (options?.includeAttendance) {
      row["Attendance Status"] =
        registration.attendanceStatus === "attended" ? "Attended" : "Not Attended";
    }

    row["Payment Received"] = registration.payment_intent_id ? "Yes" : "No";

    return row;
  });

  const worksheet =
    rows.length > 0
      ? XLSX.utils.json_to_sheet(rows)
      : XLSX.utils.aoa_to_sheet([
          [
            "Submitted",
            ...fieldIds.map(getRegistrationFieldLabel),
            ...(options?.includeAttendance ? ["Attendance Status"] : []),
            "Payment Received",
          ],
        ]);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");

  const safeName = eventName.replace(/[^a-z0-9]/gi, "_").toLowerCase() || "event";
  const date = new Date().toISOString().split("T")[0];
  XLSX.writeFile(workbook, `${safeName}_registrations_${date}.xlsx`);
}
